
import React, { useState, useEffect } from 'react';
import '../Styles/BootScreen.css';

const BootScreen = () => {
    const [showBootScreen, setShowBootScreen] = useState(null); 

    useEffect(() => {
        const hasVisited = localStorage.getItem('hasVisited');

        if (hasVisited) {
          
            setShowBootScreen(false);
        } else {
         
            setShowBootScreen(true);

            const timer = setTimeout(() => {
                setShowBootScreen(false);
                localStorage.setItem('hasVisited', 'true'); 
            }, 3000); 
           
            return () => clearTimeout(timer);
        }
    }, []);

    if (showBootScreen === null) {
        return null; 
    }

    return (
        <div className={`boot-screen ${showBootScreen ? '' : 'hide'}`}>
            <div className="loader"></div>
            <div className="message">Booting philipjanssonOS...</div>
        </div>
    );
};

export default BootScreen;
